"use strict";

let BulmaModal = {
    options: {
        selector: ".modal",
        trigger_selector: ".js-modal-trigger",
    },
};

BulmaModal.init = function (userOptions) {
    for (var prop in userOptions) {
        if (Object.prototype.hasOwnProperty.call(this.options, prop)) {
            this.options[prop] = userOptions[prop];
        }
    }

    this.initSelectors(document);

    document.addEventListener('keydown', (event) => {
        if(event.key === "Escape") {
            this.closeAll();
        }
    });
}

BulmaModal.initSelectors = function (rootElement) {
    const self = this;
    (document.querySelectorAll(this.options.trigger_selector) || []).forEach((trigger) => {
        const modal = trigger.dataset.target;
        const target = document.getElementById(modal);

        if (trigger.hasOwnProperty('moduleBulmaModalTriggerInitialized')) { return; }
        trigger.moduleBulmaModalTriggerInitialized = true;
        trigger.addEventListener('click', () => {
            self.open(target);
        });
    });

    (document.querySelectorAll('.modal-background, .modal-close, .modal-card-head .delete, .modal-card-foot .button') || []).forEach((close) => {
        const target = close.closest(this.options.selector);
        if (target === null) { return; }

        const self = this;

        if (close.hasOwnProperty('moduleBulmaModalCloseInitialized')) { return; }
        close.moduleBulmaModalCloseInitialized = true;
        close.addEventListener('click', () => {
            self.close(target);
        });
    });
}

BulmaModal.open = function (element) {
    element.classList.add('is-active');
}

BulmaModal.close = function (element) {
    element.classList.remove('is-active');
}

BulmaModal.closeAll = function() {
    const self = this;
    (document.querySelectorAll(self.options.selector) || []).forEach((modal) => {
        self.close(modal);
    });
}

export { BulmaModal };